import { ThunkMiddleware } from 'redux-thunk';
import { APP_INIT, UPDATE_IFRAME_HEIGHT, RESET_IFRAME_HEIGHT } from '../application/types';
import { IFrameHandler } from '../../services';
import { IframeUtility } from '@inter-ikea-kompis/utilities';
import { Actions, RootState } from '..';

let iframeHandler: IFrameHandler | null = null;

const iframeHandlerMiddleware: ThunkMiddleware<RootState, Actions> =
	(api) =>
	(next) =>
	(action: Actions): Actions => {
		const result = next(action);
		switch (action.type) {
			case APP_INIT: {
				iframeHandler = new IFrameHandler(api.getState().settings.settings);
				break;
			}
			case UPDATE_IFRAME_HEIGHT: {
				if (iframeHandler) {
					iframeHandler.updateIframeHeight(action.value);
				}
				break;
			}
			case RESET_IFRAME_HEIGHT: {
				if (iframeHandler) {
					iframeHandler.resetIframeHeight();
					const {
						deviceInfo: { platform: platform },
						application: { currentLightbox: currentLightbox },
					} = api.getState();

					if (
						platform === 'web' &&
						['product-intro-gallery', 'save-for-later', 'none'].includes(currentLightbox)
					) {
						const element = document.getElementById('app');
						if (element) {
							IframeUtility.scrollToElement({ element: element });
						}
					}
				}
				break;
			}
		}
		return result;
	};

export { iframeHandlerMiddleware };
